import ProjectListQueryReducer from "src/reducers/ProjectListQueryReducer";
import RevisionListQueryReducer from "src/reducers/RevisionListQueryReducer";
import ProfileListQueryReducer from "src/reducers/ProfileListQueryReducer"
import RevisionSaveReducer from "src/reducers/RevisionSaveReducer";
import FutureFeeConfigQueryReducer from "./FutureFeeConfigQueryReducer";
import FutureFeeConfigSaveReducer from "./FutureFeeConfigSaveReducer";
import FutureFeeConfigDeleteReducer from "src/reducers/FutureFeeConfigDeleteReducer";
import {
    FeeTypeNamesReducer,
    FeeTypeExampleQueryReducer,
    FeeTypeExampleSaveReducer,
    FeeTypeExampleCreateReducer,
    FeeTypeExampleDeleteReducer,
    FeeTypeExampleVersionsReducer,
    ActivateVersionReducer,
    FeeTypeExampleUIReducer
} from "src/reducers/FeeTypeExampleReducers";

function createReducer() {
    let reducers = {
        projectListRes: ProjectListQueryReducer,
        revisionListRes: RevisionListQueryReducer,
        profileListRes: ProfileListQueryReducer,
        revisionSaveRes: RevisionSaveReducer,
        futureFeeConfigRes: FutureFeeConfigQueryReducer,
        futureFeeConfigSaveRes: FutureFeeConfigSaveReducer,
        futureFeeConfigDeleteRes: FutureFeeConfigDeleteReducer,
        feeTypeNamesRes: FeeTypeNamesReducer,
        feeTypeExampleRes: FeeTypeExampleQueryReducer,
        feeTypeExampleVersionsRes: FeeTypeExampleVersionsReducer,
        feeTypeExampleSaveRes: FeeTypeExampleSaveReducer,
        feeTypeExampleCreateRes: FeeTypeExampleCreateReducer,
        feeTypeExampleDeleteRes: FeeTypeExampleDeleteReducer,
        activateVersionRes: ActivateVersionReducer,
        feeTypeExampleUIState: FeeTypeExampleUIReducer,
    };

    return reducers;
}

export default createReducer();
